import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.rate.gl.Filter.Statement.Connector,
    graphql.schema.GeneralLedgerFilterStatementConnector
  >({
    [ents.extra.rate.gl.Filter.Statement.Connector.And]:
      graphql.schema.GeneralLedgerFilterStatementConnector.And,
    [ents.extra.rate.gl.Filter.Statement.Connector.Or]:
      graphql.schema.GeneralLedgerFilterStatementConnector.Or,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.GeneralLedgerFilterStatementConnector,
    ents.extra.rate.gl.Filter.Statement.Connector
  >({
    [graphql.schema.GeneralLedgerFilterStatementConnector.And]:
      ents.extra.rate.gl.Filter.Statement.Connector.And,
    [graphql.schema.GeneralLedgerFilterStatementConnector.Or]:
      ents.extra.rate.gl.Filter.Statement.Connector.Or,
  }),
)
